import { createFileRoute, redirect } from "@tanstack/react-router"

import { dashboardPath } from "@/features/auth/panel-routes"
import { usePanelStore } from "@/features/auth/panel-store"
import { useAuthStore } from "@/features/auth/store"

/**
 * Root index — kullanıcının panel durumuna göre yönlendirir.
 *  - Auth yoksa /login (eski davranış: _authed gate'ine düşmeden direkt)
 *  - Aktif panel set ise o panelin dashboard'una
 *  - Tek panel sahibi ise o panele
 *  - Çift panel + aktif yok ise /select-panel
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const auth = useAuthStore.getState()
    if (!auth.isAuthenticated()) {
      throw redirect({ to: "/login" })
    }
    const panels = auth.user?.panels ?? []
    const active = usePanelStore.getState().active
    if (active) {
      throw redirect({ to: dashboardPath(active) })
    }
    const [first] = panels
    if (panels.length === 1 && first) {
      usePanelStore.getState().setActive(first)
      throw redirect({ to: dashboardPath(first) })
    }
    if (panels.length > 1) {
      throw redirect({ to: "/select-panel" })
    }
    auth.clear()
    throw redirect({ to: "/login" })
  },
})
